import React from 'react';

import styled from 'styled-components';

const Container = styled.div`
  font-size: 12px;
  color: var(--text-secondary);
  line-height: 1.5;
`;

type Props = {
  questions: string[];
};

const SalesPlaybookQuestionList = ({ questions }: Props) => (
  <Container>
    {questions.map((q, i) => (
      <div key={i}>"{q}"{i < questions.length - 1 ? '  ' : ''}</div>
    ))}
  </Container>
);

export default SalesPlaybookQuestionList;
